// extracted by mini-css-extract-plugin
module.exports = {"top-label":"simple-title-and-text-block_top-label__nuzAa","description":"simple-title-and-text-block_description__WSEtZ"};